import { environment } from '@/environments/environment.development';
import { computed, inject, Injectable, signal } from '@angular/core';
import { BaseService } from '../base/base.service';
import { LocalStorageService } from '../localStorage/local-storage.service';
import { ClubService } from '../club/club.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  protected url = environment;
  private baseService = inject(BaseService);
  private localStorageService = inject(LocalStorageService);
  private clubService = inject(ClubService);
  private router = inject(Router);

  private profileSignal = signal<any>(null);
  readonly profile = this.profileSignal.asReadonly();
  readonly isAuthenticated = computed(() => this.localStorageService.getToken() !== null);

  login(data: any) {
    return this.baseService.create(`${this.url.endPoint.login}`, data);
  }

  refreshToken(data: any) {
    return this.baseService.create(`${this.url.endPoint.refreshToken}`, data);
  }

  requestResetPassword(data: any) {
    return this.baseService.create(`${this.url.endPoint.requestResetPassword}`, data);
  }

  resentOtp(data: any, type: string = 'ACTIVATION') {
    const targetType = type || data?.type || 'ACTIVATION';
    return this.baseService.create(`auth/resent-otp/${targetType}/`, data);
  }

  verifyOtp(data: any, type: string = 'ACTIVATION') {
    const targetType = type || data?.type || 'ACTIVATION';
    return this.baseService.create(`auth/verify-otp/${targetType}/`, data);
  }

  resetPassword(data: any) {
    return this.baseService.create(`${this.url.endPoint.resetPassword}`, data);
  }

  updatePassword(data: any) {
    return this.baseService.update(`${this.url.endPoint.updatePassword}`, data);
  }

  updateProfile(data: any) {
    return this.baseService.update(`${this.url.endPoint.me}`, data);
  }

  updateGym(slug: string, data: any) {
    return this.baseService.update(`gym/${slug}`, data);
  }

  logout() {
    const identifier = localStorage.getItem('fcm_device_pk') || localStorage.getItem('fcm_token');
    if (identifier) {
      this.baseService.delete('device', identifier).subscribe({
        next: () => this.proceedLogout(),
        error: () => this.proceedLogout()
      });
    } else {
      this.proceedLogout();
    }
  }

  private proceedLogout() {
    this.profileSignal.set(null);
    this.clubService.setClubs([]);
    this.localStorageService.clearAll();
    this.router.navigate(['/auth']);
  }

  me() {
    return this.baseService.getAll(`${this.url.endPoint.me}`);
  }

  loadUserProfile() {
    return this.me().pipe(
      tap((response: any) => {
        if (response && response.success && response.data) {
          this.profileSignal.set(response.data);
        }
      })
    );
  }
}
